import { reducer as formReducer } from 'redux-form'
import ThemeOptions from './ThemeOptions';
import Layout from './Layout';
import Auth from './Auth';
import { teamsReducer } from './Team';
import { liveScoreReducer } from './liveScore';
export default {
  Auth,
  ThemeOptions,
  Layout,
  form: formReducer,
  teams: teamsReducer,
  score: liveScoreReducer,
}


// WEBPACK FOOTER //
// ./src/reducers/index.js